export const CHOICES = {
  rock:     { emoji: "✊", label: "Rock",     beats: "scissors" },
  paper:    { emoji: "🖐️", label: "Paper",    beats: "rock"     },
  scissors: { emoji: "✌️", label: "Scissors", beats: "paper"    },
};

export const RESULT_CONFIG = {
  win:  { emoji: "🏆", text: "YOU WIN!",  color: "#00ffc8" },
  lose: { emoji: "💀", text: "YOU LOSE",  color: "#ff4080" },
  draw: { emoji: "🤝", text: "IT'S A DRAW!", color: "#ffd700" },
};